module.exports = __webpack_public_path__ + "static/media/YF51_0.70fbf4dc.jpg";